import config from '../config';

const getAttr = (elementId, attribute, fallback = null) => {
  const element = document.getElementById(elementId);
  if (element != null) {
    if (element.hasAttribute(attribute)) {
      return element.getAttribute(attribute);
    }
  }
  return fallback;
};

const api = getAttr('mbs3', 'data-api-url', '/api');
const appRootUrlPath = getAttr('mbs3', 'data-app-root-url-path', '/mbs');

export default {
  ...config,
  api,
  appRootUrlPath,
};
